module.exports = __webpack_public_path__ + "img/france.78e9f99b.png";